import { createAnimation, IonRouterOutlet, IonSplitPane } from '@ionic/react';
import { Redirect, Route } from 'react-router-dom';

import Menu from '../../components/menu/Menu';
import { RouteNames } from '../../models/routes.model';
import { WrapperDiv } from './Private.styles';
import SandboxPage from '../../pages/sandboxPage/SandboxPage';
import SettingsPage from '../../pages/settingsPage/SettingsPage';
import AboutPage from '../../pages/aboutPage/AboutPage';
import ProfilePage from '../../pages/profilePage/ProfilePage';
import DashboardPage from '../../pages/dashboardPage/DashboardPage';
import AutoSyncPage from '../../pages/autoSyncPage/AutoSyncPage';
import JobListPage from '../../pages/jobListPage/JobListPage';
import ClockingDetailPage from '../../pages/clockingDetailPage/ClockingDetailPage';
import AdhocClockingPage from '../../pages/adhocClockingPage/AdhocClockingPage';
import DebugLogPage from '../../pages/signinPage/debugLogPage/DebugLogPage';
import DemoPage from '../../pages/demoPage/DemoPage';

export interface IComponentProps { }

const animationBuilder = (baseEl: any, opts: any) => {
  const enteringAnimation = createAnimation()
    .addElement(opts.enteringEl)
    .fromTo('opacity', 0, 1)
    .duration(250);

  const leavingAnimation = createAnimation()
    .addElement(opts.leavingEl)
    .fromTo('opacity', 1, 0)
    .duration(250);

  const animation = createAnimation()
    .addAnimation(enteringAnimation)
    .addAnimation(leavingAnimation);

  return animation;
};

const Private: React.FC<IComponentProps> = function () {
  return (
    <WrapperDiv>
      <IonSplitPane contentId="main">
        <Menu />
        <IonRouterOutlet id="main" animation={animationBuilder}>
          <Route path="/" exact>
            <Redirect to={RouteNames.dashboard} />
          </Route>
          <Route path={RouteNames.sandbox} component={SandboxPage} />
          <Route path={RouteNames.debugLog} component={DebugLogPage} />
          <Route path={RouteNames.dashboard} component={DashboardPage} />
          <Route path={RouteNames.jobList} component={JobListPage} />
          <Route path={RouteNames.clockingDetails} component={ClockingDetailPage} />
          <Route path={RouteNames.adhocClocking} component={AdhocClockingPage} />
          <Route path={RouteNames.settings} component={SettingsPage} />
          <Route path={RouteNames.autoSync} component={AutoSyncPage} />
          <Route path={RouteNames.about} component={AboutPage} />
          <Route path={RouteNames.profile} component={ProfilePage} />
          <Route path={RouteNames.demo} component={DemoPage} />
          <Route render={() => <Redirect to='/' />} />
        </IonRouterOutlet>
      </IonSplitPane>
    </WrapperDiv>
  );
};

export default Private;
